export default {
  order: 6,
  layerGroupId: 'GROUP_LC',
  dataLayer: {
    id: 'UMD_LAND_COVER',
    order: 6,
    type: 'remoteDataLayer',
    uuid: 'f22e0529-d398-4ccc-b943-e62d420fea89',
    groupId: 'GROUP_LC',
  },
  layer: {
    metadata: {
      metadata: null,
      legendConfig: {
        name: {
          en: '2000-2020 Land Cover Map',
          fr: '2000-2020 Land Cover Map',
          es: '2000-2020 Land Cover Map',
          pt: '2000-2020 Land Cover Map',
          id: '2000-2020 Land Cover Map',
          zh: '2000-2020 Land Cover Map',
          ka: '2000-2020 Land Cover Map',
        },
        type: 'basic',
        items: [
          {
            color: 'rgb(254, 254, 204)',
            name: {
              en: 'Bare Ground',
              fr: 'Bare Ground',
              es: 'Bare Ground',
              pt: 'Bare Ground',
              id: 'Bare Ground',
              zh: 'Bare Ground',
              ka: 'Bare Ground',
            },
          },
          {
            color: 'rgb(185, 185, 30)',
            name: {
              en: 'Short Vegetation',
              fr: 'Short Vegetation',
              es: 'Short Vegetation',
              pt: 'Short Vegetation',
              id: 'Short Vegetation',
              zh: 'Short Vegetation',
              ka: 'Short Vegetation',
            },
          },
          {
            color: 'rgb(52, 120, 52)',
            name: {
              en: 'Forest',
              fr: 'Forest',
              es: 'Forest',
              pt: 'Forest',
              id: 'Forest',
              zh: 'Forest',
              ka: 'Forest',
            },
          },
          {
            color: 'rgb(13, 87, 13)',
            name: {
              en: 'Tall Forest (20m+)',
              fr: 'Tall Forest (20m+)',
              es: 'Tall Forest (20m+)',
              pt: 'Tall Forest (20m+)',
              id: 'Tall Forest (20m+)',
              zh: 'Tall Forest (20m+)',
              ka: 'Tall Forest (20m+)',
            },
          },
          {
            color: 'rgb(136, 202, 173)',
            name: {
              en: 'Wetland - Short Vegetation',
              fr: 'Wetland - Short Vegetation',
              es: 'Wetland - Short Vegetation',
              pt: 'Wetland - Short Vegetation',
              id: 'Wetland - Short Vegetation',
              zh: 'Wetland - Short Vegetation',
              ka: 'Wetland - Short Vegetation',
            },
          },
          {
            color: 'rgb(88, 149, 88)',
            name: {
              en: 'Wetland - Forest',
              fr: 'Wetland - Forest',
              es: 'Wetland - Forest',
              pt: 'Wetland - Forest',
              id: 'Wetland - Forest',
              zh: 'Wetland - Forest',
              ka: 'Wetland - Forest',
            },
          },
          {
            color: 'rgb(107, 174, 214)',
            name: {
              en: 'Water',
              fr: 'Water',
              es: 'Water',
              pt: 'Water',
              id: 'Water',
              zh: 'Water',
              ka: 'Water',
            },
          },
          {
            color: 'rgb(172, 209, 232)',
            name: {
              en: 'Snow/Ice',
              fr: 'Snow/Ice',
              es: 'Snow/Ice',
              pt: 'Snow/Ice',
              id: 'Snow/Ice',
              zh: 'Snow/Ice',
              ka: 'Snow/Ice',
            },
          },
          {
            color: 'rgb(255, 241, 131)',
            name: {
              en: 'Cropland',
              fr: 'Cropland',
              es: 'Cropland',
              pt: 'Cropland',
              id: 'Cropland',
              zh: 'Cropland',
              ka: 'Cropland',
            },
          },
          {
            color: 'rgb(232, 118, 93)',
            name: {
              en: 'Built-up Area',
              fr: 'Built-up Area',
              es: 'Built-up Area',
              pt: 'Built-up Area',
              id: 'Built-up Area',
              zh: 'Built-up Area',
              ka: 'Built-up Area',
            },
          },
        ],
      },
      interactionConfig: {},
    },
    id: 'UMD_LAND_COVER',
    type: 'umd-land-cover',
    url: 'https://storage.googleapis.com/lcl_tiles/GLCLU{year}/composite{year}/{z}/{x}/{y}.png',
    technicalName: 'umd_land_cover',
    label: {
      en: 'Land Cover 2000-2020',
      fr: 'Land Cover 2000-2020',
      es: 'Land Cover 2000-2020',
      pt: 'Land Cover 2000-2020',
      id: 'Land Cover 2000-2020',
      zh: 'Land Cover 2000-2020',
      ka: 'Land Cover 2000-2020',
    },
    sublabel: {
      en: 'Global land use and land cover map for 2000 and 2020',
      fr: 'Global land use and land cover map for 2000 and 2020',
      es: 'Global land use and land cover map for 2000 and 2020',
      pt: 'Global land use and land cover map for 2000 and 2020',
      id: 'Global land use and land cover map for 2000 and 2020',
      zh: 'Global land use and land cover map for 2000 and 2020',
      ka: 'Global land use and land cover map for 2000 and 2020',
    },
  },
  isMetadataError: false,
  isError: false,
};
